// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@/config/filterRouter'
import * as echarts from 'echarts';


Vue.config.productionTip = false
Vue.use(Vant)
Vue.prototype.$echarts = echarts
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js